import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Globals } from '../../ressources/variables/globals';

/**
 * Service pour la gestion des spots publicitaires
 * Note: L'authentification est gérée automatiquement via les cookies de session Laravel
 * grâce à l'intercepteur CredentialsInterceptor
 */
@Injectable()
export class SpotsService {

  serverEndpoint = Globals.serverEndpoint;

  public passData;

  constructor(private http: HttpClient) { }

  getWinmediaSpotsData(): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(this.serverEndpoint + '/spots/getWinmediaSpotsData', {}, { headers }).toPromise();
  }

  getPreviousCampaigns(): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(this.serverEndpoint + '/spots/getPreviousCampaigns', {}, { headers }).toPromise();
  }

  deleteRemainingSpots(campaignId: number): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const body = new HttpParams()
      .set('campaign_id', campaignId);
    return this.http.post(this.serverEndpoint + '/spots/deleteRemainingSpots', body.toString(), { headers }).toPromise();
  }

  saveCampaign(data: any): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const body = new HttpParams()
      .set('data', JSON.stringify(data));
    return this.http.post(this.serverEndpoint + '/spots/saveCampaign', body.toString(), { headers }).toPromise();
  }
}
